// extracted by mini-css-extract-plugin
export default {"FilterTabs":"styles_FilterTabs__OcvDx","list":"styles_list__7Ouqb","active":"styles_active__pZp59","title":"styles_title__l71Jq","count":"styles_count__maZ0i"};